import React, { useState } from 'react';
import styles from './navigationMobile.module.css';

const NavigationMobile = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const session_state = urlParams.get('session_state');

    // STATE
    const [toggleMenu, setToggleMenu] = useState(false);

    const toggleMobileMenu = () => {
        setToggleMenu(!toggleMenu);
    };

    return (
        <section id='edit-profile-nav-mobile' className={styles.navBar}>
            <div className='w-100 d-flex justify-content-between align-items-center'>
                <buton
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                        (window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?session_state=${session_state}`)
                    }
                >
                    <img
                        src={'assets/img/logo.svg'}
                        alt='splendi logo'
                        width={150}
                    />
                </buton>

                {/* MOBILE HAMBURGER BUTTON */}
                <button
                    onClick={toggleMobileMenu}
                    className={styles.toggleMenuButton}
                >
                    <div></div>
                    <div></div>
                    <div></div>
                </button>
            </div>
            <div
                style={{ display: toggleMenu ? 'block' : 'none' }}
                className={styles.mobileNavLinks}
            >
                <ul className={styles.navItems}>
                    <li
                        onClick={() => {
                            props.changeRoute('account');
                            setToggleMenu(false);
                        }}
                    >
                        Account
                    </li>
                    <li
                        onClick={() => {
                            props.changeRoute('password');
                            setToggleMenu(false);
                        }}
                    >
                        Password
                    </li>
                    {/* <li onClick={() => props.changeRoute('authenticator')}>
                    Authenticator
                </li> */}
                    <li
                        onClick={() => {
                            props.changeRoute('logs');
                            setToggleMenu(false);
                        }}
                    >
                        Logs
                    </li>
                    <li
                        onClick={() =>
                            (window.location.href = `${process.env.REACT_APP_REDIRECT_URL}?session_state=${session_state}`)
                        }
                    >
                        Back To Splendi
                    </li>
                </ul>
                <div
                    style={{ paddingLeft: '20px' }}
                    className='d-flex gap-4 align-items-center pb-3'
                >
                    {props.userData !== null && props.userData !== undefined ? (
                        <>
                            <img
                                src='assets/img/generic_avatar.svg'
                                alt='users avatar'
                                width={45}
                            />
                            <span>{`${props.userData.firstName} ${props.userData.lastName}`}</span>
                        </>
                    ) : (
                        <span
                            style={{ width: '20px', height: '20px' }}
                            className='spinner-border spinner-border-sm'
                        ></span>
                    )}
                </div>
            </div>
        </section>
    );
};

export default NavigationMobile;
